import { t } from 'i18next';
import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { DispatchURLParams, OrdersAssignedTargetEntity } from '~constants/dispatch';
import { useStores } from '~store';

import StatusTabs, { StatusTab } from '../Tabs/StatusTabs';

const tabs: StatusTab<OrdersAssignedTargetEntity>[] = [
  { label: t('page_headings.orders'), value: OrdersAssignedTargetEntity.ORDERS },
  { label: t('page_headings.projects'), value: OrdersAssignedTargetEntity.PROJECTS },
];

export default function SalespersonViewSelector() {
  const { ordersAssignedStore } = useStores();

  const [searchParams, setSearchParams] = useSearchParams();

  const currentTab = searchParams.get(
    DispatchURLParams.ENTITY,
  ) as OrdersAssignedTargetEntity;
  const isValidTab = Object.values(OrdersAssignedTargetEntity).includes(currentTab);

  const handleSelectedTabChange = useCallback(
    (value: OrdersAssignedTargetEntity) => {
      setSearchParams((params) => {
        params.set(DispatchURLParams.ENTITY, value);

        return params;
      });
    },
    [setSearchParams],
  );

  useEffect(() => {
    if (isValidTab) {
      ordersAssignedStore.setTargetEntity(currentTab);
    } else {
      setSearchParams((params) => {
        params.set(DispatchURLParams.ENTITY, OrdersAssignedTargetEntity.ORDERS);

        return params;
      });
    }
  }, [isValidTab, currentTab, setSearchParams]);

  if (!isValidTab) {
    return null;
  }

  return (
    <StatusTabs onChange={handleSelectedTabChange} selectedTab={currentTab} tabs={tabs} />
  );
}
